export const queryKeys = {
  base: () => ['edge', 'groups'] as const,
};
